import { NewCleavageEvent } from '../events/newCleavage/NewCleavageEvent';
import { UseCase } from './UseCase';
export class CheckAutoplayUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.autoplay.hasAutoplay()
            .then(hasAutoplay => hasAutoplay ? this.onAutoPlay() : Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onAutoPlay() {
        return this.applicationServices.autoplay.isTimeForNextCleavage()
            .then(isTimeForNextCleavage => isTimeForNextCleavage
            ? this.onTimeForNextCleavage()
            : Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onTimeForNextCleavage() {
        return Promise.resolve([
            this.applicationServices.autoplay.configureNextAutoPlay(),
            this.applicationServices.event.sentEvent(new NewCleavageEvent())
        ])
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
}
